
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";
import { trackSearchInteraction } from "@/utils/searchTracking";

interface VacationActionButtonProps {
  vacation: any;
  searchQuery?: string;
  position?: number;
}

export const VacationActionButton = ({ vacation, searchQuery, position }: VacationActionButtonProps) => {
  const handleViewMore = async () => {
    // Track the click interaction
    if (searchQuery && position !== undefined) {
      await trackSearchInteraction({
        interactionType: 'click',
        searchQuery,
        clickedVacationId: vacation['product ID'],
        vacationPosition: position
      });
    }
  };

  return vacation.productURL ? (
    <a
      href={vacation.productURL}
      target="_blank"
      rel="nofollow noopener"
      onClick={handleViewMore}
      className="w-full bg-gradient-to-r from-blue-600 to-orange-500 hover:from-blue-700 hover:to-orange-600 mt-4 inline-flex items-center justify-center px-4 py-2 rounded-md text-white font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
    >
      <ExternalLink className="h-4 w-4 mr-2" />
      Bekijk meer info & prijzen
    </a>
  ) : (
    <Button 
      disabled
      className="w-full bg-gradient-to-r from-blue-600 to-orange-500 hover:from-blue-700 hover:to-orange-600 mt-4"
    >
      <ExternalLink className="h-4 w-4 mr-2" />
      Bekijk meer info & prijzen
    </Button>
  );
};
